import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { COMMAND_PRIORITY_HIGH, KEY_DOWN_COMMAND } from 'lexical'
import { useEffect } from 'react'

export default function SubmitShortcutPlugin({ onSubmit }: { onSubmit: () => void }) {
	const [editor] = useLexicalComposerContext()

	useEffect(() => {
		return editor.registerCommand(
			KEY_DOWN_COMMAND,
			(event: KeyboardEvent) => {
				if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
					event.preventDefault()
					onSubmit()
					return true
				}
				return false
			},
			COMMAND_PRIORITY_HIGH
		)
	}, [editor, onSubmit])

	return null
}
